// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__3tClb","content":"Consent_content__2lBJU","footer":"Consent_footer__1SVJ4"};